import React, { useEffect, useState } from 'react'
import { auth, db } from '../firebaseconfig'
import { useAuthState } from 'react-firebase-hooks/auth'
import { CircularProgress } from '@mui/material'
import ResultTable from '../components/ResultTable'
import { Graph } from '../components/Graph'
import { Usercard } from '../components/Usercard'

const Userpage = () => {
  const [data,setdata]=useState([])
  const[dataLoding,setdataLoading]=useState(true)
  const [user,loading]=useAuthState(auth)
  const [graphData,setgraphdata]=useState([])

  const fetchUserData =()=>{
    const resultRef=db.collection('Results')
    const {uid}=auth.currentUser;
    let tempData=[];
    let tempgraphData=[];
    resultRef.where('userId','==',uid).orderBy('timeStamp','desc').get().then((snapshot)=>{
      snapshot.docs.forEach((doc)=>{
        tempData.push({...doc.data()})
        tempgraphData.push([doc.data().timeStamp.toDate().toLocaleString().split(',')[0], doc.data().wpm])
        console.log(doc.data())
      })
      setdata(tempData)
      setgraphdata(tempgraphData.reverse())
      setdataLoading(false)
    })
  }

  useEffect(()=>{
    if(!loading && user)
    {
      fetchUserData()
    }
    
  },[loading])
  if(!user && !user)
  {
    return <div className='screen-center'><span>Login to view the result</span></div>
  }
  if(loading || dataLoding)
  {
    return <div className='screen-center '><CircularProgress size={240} /></div>
  }
  
  return (
    <div className='canvas'>
    <Usercard totalTests={data.length}/>
    <div className='user-page-graph'>
      <Graph graphdata={graphData} />
    </div>
      <ResultTable data={data}/>
    </div>
  )
}
export  default Userpage
